module.exports = __webpack_public_path__ + "img/confirmOrder.be20fccf.png";